import React from "react";

import CloseIcon from "public/icons/close.svg";

import { Old_Button } from "@/components/form/Button/Old_Button";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";

import { CommonModalProps } from "../models";

type PropTypes = CommonModalProps & {
  imgUrl: string;
};

export const SweetOrHotModal: React.FC<PropTypes> = ({ onClose, imgUrl }) => {
  return (
    // <div className="w-[100vw] h-[100vh] flex flex-col justify-center items-center">
    <div className="flex flex-col justify-center items-center">
      <Old_Button
        variant="text"
        className="absolute right-1 top-1"
        onClick={onClose}
      >
        <SvgIcon className="w-12 h-12" color="white">
          <CloseIcon />
        </SvgIcon>
      </Old_Button>
      {/* <div className="h-[80vh] relative w-[70vw] min-w-min">
        <ClickAwayListener onClickAway={onClose}>
          <Image
            unoptimized
            src={imgUrl}
            alt="Sweet or hot lady photo"
            fill
            className="object-contain bg-pink"
          />
        </ClickAwayListener>
      </div> */}

      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={imgUrl}
        alt="Sweet or hot lady photo"
        className="max-h-[80vh] max-w-[70vw]"
      />
    </div>
  );
};
